import { Component } from '@angular/core';
import { UserExperienceService } from '@app/services/user-experience.service';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebo-premium-dialog',
  templateUrl: 'premium-dialog.html',
  imports: [Button]
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class PremiumDialog {
  constructor(
    public dialogRef: DynamicDialogRef,
    private userExperience: UserExperienceService
  ) {}

  refresh() {
    this.userExperience.refreshClient();
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
